// extracted by mini-css-extract-plugin
module.exports = {"text":"_75a21731"};